module.exports = __webpack_public_path__ + "static/img/01.bff5bea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/01.jpg
// module id = zcwQ
// module chunks = 0